'use client'

import Breadcrumb from './Breadcrumb'

export type { BreadcrumbProps } from './Breadcrumb'
export type { BreadcrumbItemProps, SeparatorType } from './BreadcrumbItem'

export default Breadcrumb
